const novalidation = (element) => {
    return true
}

export default novalidation